import {useCallback, useEffect} from "react";

export const useSessionStorage = (key, defaultValue) => {
    
    const getStorageValue = useCallback(() => {
        const saved = sessionStorage.getItem(key);
        if (saved == null || saved === 'undefined' || saved === 'null') {
            return defaultValue;
        }
        const initial = JSON.parse(saved);
        return initial;
    }, [key, defaultValue]);

    const setStorageValue = useCallback((value) => {
        if (value == null) {
            value = "";
        }
        sessionStorage.setItem(key, JSON.stringify(value));
    }, [key]);

    const deleteStorageValue = useCallback(() => {
        sessionStorage.removeItem(key);
    }, [key]);

    useEffect(() => {
        const storageValue = getStorageValue();
        // storing input name
        setStorageValue(storageValue);
    }, [getStorageValue, setStorageValue]);

    return [setStorageValue, getStorageValue, deleteStorageValue ];
};